/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _slicedToArray } from '../_chunks/dep-fc63c737.mjs';
import { _ as _defineProperty } from '../_chunks/dep-b011b919.mjs';
import { defineComponent, toRefs, computed, watch, h, createVNode } from 'vue';
import { usePrefixClass, useCommonClassName } from '../hooks/useConfig.mjs';
import { Loading } from '../loading/index.mjs';
import props from './props.mjs';
import { useFormDisabled } from '../form/hooks.mjs';
import useVModel from '../hooks/useVModel.mjs';
import { i as isFunction_1 } from '../_chunks/dep-8d19eb1a.mjs';
import { i as isString_1 } from '../_chunks/dep-7f2f03b4.mjs';
import { i as isArray_1 } from '../_chunks/dep-b9567f6a.mjs';
import '../_chunks/dep-2a2a0e63.mjs';
import '../_chunks/dep-ae1abe1d.mjs';
import '../config-provider/useConfig.mjs';
import '../_chunks/dep-adebe2ce.mjs';
import '../_chunks/dep-eba62589.mjs';
import '../_chunks/dep-bd3d75f1.mjs';
import '../_chunks/dep-2b8d75e2.mjs';
import '../_chunks/dep-8f44163a.mjs';
import '../_chunks/dep-a255de71.mjs';
import '../_chunks/dep-ebe8bc2f.mjs';
import '../_chunks/dep-7d9e11c8.mjs';
import '../_chunks/dep-16e2f1a5.mjs';
import '../_chunks/dep-cc371884.mjs';
import '../_chunks/dep-1f0070bb.mjs';
import '../_chunks/dep-9d0d32fd.mjs';
import '../_chunks/dep-ebfafd52.mjs';
import '../_chunks/dep-a6022780.mjs';
import '../_chunks/dep-654b4b01.mjs';
import '../_chunks/dep-a11a63ea.mjs';
import '../_chunks/dep-750294df.mjs';
import '../_chunks/dep-ad1accf9.mjs';
import '../_chunks/dep-e05e20e6.mjs';
import '../_chunks/dep-3e3494dc.mjs';
import '../_chunks/dep-42be3824.mjs';
import '../_chunks/dep-67dfe9c7.mjs';
import '../_chunks/dep-a0bd2e3a.mjs';
import '../_chunks/dep-91208ac3.mjs';
import '../_chunks/dep-1041f7d7.mjs';
import '../_chunks/dep-b32fb318.mjs';
import '../_chunks/dep-9b57842b.mjs';
import '../_common/js/global-config/default-config.mjs';
import '../_common/js/global-config/locale/zh_CN.mjs';
import '../_chunks/dep-99a0abba.mjs';
import '../_chunks/dep-9d5ee0e1.mjs';
import '../config-provider/type.mjs';
import '../loading/directive.mjs';
import '../loading/plugin.mjs';
import '../loading/loading.mjs';
import '../loading/icon/gradient.mjs';
import '../_common/js/loading/circle-adapter.mjs';
import '../_common/js/utils/set-style.mjs';
import '../_common/js/utils/helper.mjs';
import '../_chunks/dep-56ceb7ce.mjs';
import '../_chunks/dep-c3626417.mjs';
import '../_chunks/dep-e00db566.mjs';
import '../_chunks/dep-fdde96c5.mjs';
import '../_chunks/dep-961339ce.mjs';
import '../utils/dom.mjs';
import '../utils/easing.mjs';
import '../utils/render-tnode.mjs';
import '../_chunks/dep-ff1c0573.mjs';
import '../_chunks/dep-f50ac97c.mjs';
import '../_chunks/dep-94585de3.mjs';
import '../_chunks/dep-06221fe2.mjs';
import '../_chunks/dep-d7053a2c.mjs';
import '../_chunks/dep-f3e3393e.mjs';
import '../_chunks/dep-0fa7026c.mjs';
import '../_chunks/dep-31dc9d09.mjs';
import '../_chunks/dep-b9d74a58.mjs';
import '../loading/props.mjs';
import '../hooks/useTeleport.mjs';
import '../utils/withInstall.mjs';
import './style/css.mjs';
import '../loading/type.mjs';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var _Switch = defineComponent({
  name: "TSwitch",
  props: _objectSpread({}, props),
  setup: function setup(props2, _ref) {
    var slots = _ref.slots;
    var disabled = useFormDisabled();
    var COMPONENT_NAME = usePrefixClass("switch");
    var _useCommonClassName = useCommonClassName(),
      STATUS = _useCommonClassName.STATUS,
      SIZE = _useCommonClassName.SIZE;
    var _toRefs = toRefs(props2),
      value = _toRefs.value,
      modelValue = _toRefs.modelValue;
    var _useVModel = useVModel(value, modelValue, props2.defaultValue, props2.onChange),
      _useVModel2 = _slicedToArray(_useVModel, 2),
      innerValue = _useVModel2[0],
      setSwitchVal = _useVModel2[1];
    var activeValue = computed(function () {
      if (props2.customValue && props2.customValue.length > 0) {
        return props2.customValue[0];
      }
      return true;
    });
    var inactiveValue = computed(function () {
      if (props2.customValue && props2.customValue.length > 1) {
        return props2.customValue[1];
      }
      return false;
    });
    function handleToggle() {
      var checked = innerValue.value === activeValue.value ? inactiveValue.value : activeValue.value;
      setSwitchVal(checked);
    }
    function toggle() {
      if (disabled.value || props2.loading) {
        return;
      }
      handleToggle();
    }
    var classes = computed(function () {
      var _ref2;
      return ["".concat(COMPONENT_NAME.value), SIZE.value[props2.size], (_ref2 = {}, _defineProperty(_ref2, STATUS.value.disabled, disabled.value), _defineProperty(_ref2, STATUS.value.loading, props2.loading), _defineProperty(_ref2, STATUS.value.checked, innerValue.value === activeValue.value || props2.modelValue === activeValue.value), _ref2)];
    });
    var nodeClasses = computed(function () {
      var _ref3;
      return ["".concat(COMPONENT_NAME.value, "__handle"), (_ref3 = {}, _defineProperty(_ref3, STATUS.value.disabled, disabled.value), _defineProperty(_ref3, STATUS.value.loading, props2.loading), _ref3)];
    });
    var contentClasses = computed(function () {
      return ["".concat(COMPONENT_NAME.value, "__content"), SIZE.value[props2.size], _defineProperty({}, STATUS.value.disabled, disabled.value)];
    });
    watch(innerValue, function (val) {
      if (props2.customValue && props2.customValue.length && !props2.customValue.includes(val)) {
        throw new Error("value is not in ".concat(JSON.stringify(props2.customValue)));
      }
    }, {
      immediate: true
    });
    var content = computed(function () {
      if (isFunction_1(props2.label)) {
        return props2.label(h, {
          value: innerValue.value
        });
      }
      if (isString_1(props2.label)) {
        return props2.label;
      }
      if (isArray_1(props2.label) && props2.label.length) {
        var label = innerValue.value === activeValue.value ? props2.label[0] : props2.label[1];
        if (!label) return;
        if (isString_1(label)) {
          return label;
        }
        if (isFunction_1(label)) {
          return label(h);
        }
      }
      if (slots.label) {
        return slots.label({
          value: innerValue.value
        });
      }
      return null;
    });
    return function () {
      var switchContent;
      var loadingContent;
      if (props2.loading) {
        loadingContent = createVNode(Loading, {
          "size": "small"
        }, null);
      } else if (content.value) {
        switchContent = content.value;
      }
      return createVNode("div", {
        "class": classes.value,
        "disabled": disabled.value,
        "onClick": toggle
      }, [createVNode("span", {
        "class": nodeClasses.value
      }, [loadingContent]), createVNode("div", {
        "class": contentClasses.value
      }, [switchContent])]);
    };
  }
});

export { _Switch as default };
//# sourceMappingURL=switch.mjs.map
